import { logout } from "@apis:auth/auth";
import { storage } from "@utils:token-storage";
import { useEffect } from "react";

export const Logout = () => {
  useEffect(() => {
    const run = async () => {
      await logout().catch(() => undefined);
      storage.clearToken();
      window.location.assign(window.location.origin as unknown as string);
    };
    void run();
  }, []);

  return null;
};
